export default __webpack_public_path__ + "static/media/talitafelyx.a7f4b8b9.jpg";